import { FunctionComponent } from 'react';
import { useAuth } from '../../../lib/providers/authProvider';
import Riasec from '../../icons/RIASEC';
import Image from "next/legacy/image";
import Program from 'wwg-utilities/dist/collections/program';
import WageDataComponent from '../../shared/WageData';
import useLocalSalaryData from '../../../lib/hooks/localSalaryData';
import { isSkillup } from '../../../lib/config/project/project';
import { Region } from '../../../lib/providers/regionProvider';
interface CareerBoxProps {
  program: Program;
  region: Region;
}

const CareerBox: FunctionComponent<CareerBoxProps> = ({
  program,
  region,
}) => {
  const { seeker } = useAuth();

  const {
    medianAnnualSalary,
    entryAnnualSalary,
    entryHourlyWage,
    medianHourlyWage,
    highAnnualSalary,
    highHourlyWage,
  } = useLocalSalaryData(
    program?.primaryCareerData?.career?.onetCode || '',
    program,
    seeker,
    region.location,
  );

  return (
    <div className="p-2 my-4 bg-md-gray md:p-6">
      <div className="flex items-center">
        <div className="w-10 h-10">
          <div className="p-2 bg-white rounded-full">
            <Image
              src="https://res.cloudinary.com/wherewego/image/upload/v1648313769/WWG2000%20Site%20Photos/ym5hnejkndu6dcfdhtzd.png"
              blurDataURL="https://res.cloudinary.com/wherewego/image/upload/v1648313769/WWG2000%20Site%20Photos/ym5hnejkndu6dcfdhtzd.png"
              placeholder="blur"
              loading="eager"
              layout="responsive"
              width={2500}
              height={2000}
              alt="CareerOneStop Logo"
            />
          </div>
        </div>
        <div className="flex flex-col w-full pl-4">
          <div className="flex items-center justify-between w-full">
            <div>
              <p className="text-xs">Example Career</p>
              <p className="text-2xl font-bold">
                {program.primaryCareerData?.career?.careerName}
              </p>
            </div>
            <div className="flex flex-wrap hidden ml-4 md:ml-auto md:flex">
              {program.industries?.map((industry: string) => {
                return (
                  <div
                    key={industry}
                    className="flex px-3 py-2 m-1 ml-auto text-xs font-bold bg-riasec text-riasec-text shrink font-base"
                  >
                    {industry}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
      <div className="block my-4 md:flex">
        <p className="text-sm md:flex-1">
          {program.primaryCareerData?.career?.description}
        </p>
        <div className="flex flex-wrap pt-2 md:hidden">
          {program.industries?.map((industry: string) => {
            return (
              <div
                key={industry}
                className="flex px-3 py-2 m-1 text-xs font-bold bg-riasec text-riasec-text font-base"
              >
                {industry}
              </div>
            );
          })}
        </div>
        {program.otherCareers && program.otherCareers.length ? (
          <div className="my-4 md:my-0 md:mx-4 md:flex-1">
            <p className="text-sm font-bold">Other Careers</p>
            <div className="flex flex-wrap">
              {program.otherCareers.map((career: string, index: number) => {
                return (
                  <p key={`career${index}`} className="text-xs my-0.5 flex-50">
                    {career}
                  </p>
                );
              })}
            </div>
          </div>
        ) : (
          ''
        )}
      </div>

      <WageDataComponent
        entryAnnualSalary={entryAnnualSalary || program.primaryCareerData?.wageData?.entryAnnualSalary?.value || 0}
        entryHourlyWage={entryHourlyWage || program.primaryCareerData?.wageData?.entryHourlyWage?.value || 0}
        medianAnnualSalary={medianAnnualSalary || program.primaryCareerData?.wageData?.medianAnnualSalary?.value || 0}
        medianHourlyWage={medianHourlyWage || program.primaryCareerData?.wageData?.medianHourlyWage?.value || 0}
        highAnnualSalary={highAnnualSalary || program.primaryCareerData?.wageData?.highAnnualSalary?.value || 0}
        highHourlyWage={highHourlyWage || program.primaryCareerData?.wageData?.highHourlyWage?.value || 0}
        textColorClass={isSkillup ? 'text-training' : 'text-primary'}
        borderRadiusClass="rounded-2xl"
        region={region.location}
      />
      <div className="flex flex-wrap my-6">
        {program.primaryCareerData?.career?.riasec?.map((quality: string) => {
          return (
            <div
              key={quality}
              className="flex items-center px-3 py-2 mx-1 my-1 text-sm font-bold bg-riasec text-riasec-text font-base"
            >
              <Riasec
                className={'h-6 w-6 fill-riasec-text mr-2'}
                quality={quality}
              />
              {quality}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CareerBox;
